import { useState } from 'react';

import { useNavigate } from '@tanstack/react-router';

import { AccountLockedCard } from '@/entities/account';

import { SignInForm } from './sign-in-page/sign-in-form';
import { SignInUnlockFlow } from './sign-in-page/sign-in-unlock-flow';

type Props = {
    role: string;
    returnUrl?: string;
    unlockToken?: string;
};

export function SignInPage({ role, returnUrl, unlockToken }: Props) {
    const navigate = useNavigate();
    const [resent, setResent] = useState<{ email: string | null } | null>(null);

    // Stripping the token unmounts the unlock-flow subtree, so the resent state lives on the
    // page. Either branch lands on the locked screen: a composite token carries the email to
    // interpolate, a legacy/opaque one falls back to generic copy.
    const handleResent = (email: string | null) => {
        setResent({ email });
        void navigate({ to: '/login', search: {}, replace: true });
    };

    if (resent) {
        return <AccountLockedCard email={resent.email ?? undefined} />;
    }

    if (unlockToken) {
        return <SignInUnlockFlow token={unlockToken} onResent={handleResent} />;
    }

    return <SignInForm role={role} returnUrl={returnUrl} />;
}
